import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVerzwakken = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M16.5 12.5H7.5C7.22 12.5 7 12.28 7 12C7 11.72 7.22 11.5 7.5 11.5H16.5C16.78 11.5 17 11.72 17 12C17 12.28 16.78 12.5 16.5 12.5Z' />
    <path d='M12 22.5C6.21 22.5 1.5 17.79 1.5 12C1.5 6.21 6.21 1.5 12 1.5C17.79 1.5 22.5 6.21 22.5 12C22.5 17.79 17.79 22.5 12 22.5ZM12 2.5C6.76 2.5 2.5 6.76 2.5 12C2.5 17.24 6.76 21.5 12 21.5C17.24 21.5 21.5 17.24 21.5 12C21.5 6.76 17.24 2.5 12 2.5Z' />
  </svg>
);
export default SvgVerzwakken;
